import { useEffect, useState } from 'react';

import { toast } from 'react-toastify';

import AppSideBar from '../../ui-components/AppSideBar';

import FileUploadField from './FileUploadField';
import { FileSetting } from './model';
import {
  useLazyGetFileSettingsQuery,
  useFileUploadMutation,
} from './settingsApi';

export default function FilesSettingPage() {
  const [trigger, { data, isLoading, isError }] = useLazyGetFileSettingsQuery();
  const [fileupload] = useFileUploadMutation();

  const [groupTypeArr, setGroupTypeArr] = useState<string[]>([]);
  const [selectedGroup, setSelectedGroup] = useState('');
  const [filteredSettings, setFilteredSettings] = useState<FileSetting[]>([]);
  const [searchTerm, setSearchTerm] = useState('');

  const allSettings: FileSetting[] = data?.data || [];

  useEffect(() => {
    trigger({ type: 'files' });
  }, [trigger]);

  useEffect(() => {
    if (allSettings.length) {
      const groups = [...new Set(allSettings.map((s) => s.groupType))];
      setGroupTypeArr(groups);
      setSelectedGroup((prev) => prev || groups[0]);
    }
  }, [allSettings]);

  useEffect(() => {
    const groupSettings = allSettings.filter(
      (s) => s.groupType === selectedGroup
    );
    setFilteredSettings(groupSettings);
  }, [selectedGroup, allSettings]);

  const handleFileUpload = async (settingKey: string, file: File) => {
    const formData = new FormData();
    formData.append('setting_file', file);
    formData.append('replace_index', '0');
    formData.append('setting_key', settingKey);

    try {
      const res = await fileupload(formData).unwrap();
      trigger({ type: 'files' });
      toast.success(res?.settings?.message || 'File uploaded successfully');
    } catch (err: unknown) {
      toast.error(err?.settings?.message || 'Upload failed');
    }
  };

  if (isLoading) {
    return <div className="p-6">Loading settings...</div>;
  }
  if (isError) {
    return <div className="p-6 text-red-600">Failed to load settings</div>;
  }

  return (
    <div className="flex p-6 gap-6">
      <AppSideBar
        groupTypeArr={groupTypeArr}
        selectedGroup={selectedGroup}
        onSelect={setSelectedGroup}
        searchTerm={searchTerm}
        onSearchChange={setSearchTerm}
        showSearch={false}
      />

      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 flex-1 overflow-auto">
        {filteredSettings.map((setting) => (
          <FileUploadField
            key={setting.name}
            label={setting.description}
            value={setting.value}
            fileName={setting.fileName}
            accept={setting?.sourceValue?.FILE_EXT?.split(',')
              .map((ext) => `.${ext}`)
              .join(',')}
            helpText={setting.helpText}
            infoText={setting.sourceValue?.FILE_EXT}
            onUpload={(file) => handleFileUpload(setting.name, file)}
          />
        ))}
      </div>
    </div>
  );
}
